import md5 from "blueimp-md5"
import * as _date from "date-fns"
import { parseISO } from "date-fns/fp"
// -- import * as _ from "lodash-es"
import numbro from "numbro"

export const merge = function (
  targetObject,
  sourceObject,
  createPropertyWhenNotExists
) {
  if (createPropertyWhenNotExists) {
    _.each(sourceObject, (v, k) => {
      targetObject[k] = v
    })
  } else {
    _.each(sourceObject, (v, k) => {
      if (targetObject.hasOwnProperty(k)) targetObject[k] = v
    })
  }

  return targetObject
}

export const findIndexAll = function (array, search_by) {
  let indexes = []
  let index = _.findIndex(array, search_by)
  while (index !== -1) {
    indexes.unshift(index)
    index = _.findIndex(array, search_by, index + 1)
  }
  return indexes
}

export const display_number_value = function (value, _precise = 0) {
  if (!_.isNumber(value)) return ""
  if (_precise === undefined || _precise === 0) {
    return numbro(value).format({ thousandSeparated: true })
  } else {
    if (value == null) {
      //value == 0
      return numbro.zeroFormat("")
    } else {
      return numbro(value).format({
        thousandSeparated: true,
        trimMantissa: true,
        mantissa: _precise
      })
    }
  }
}

export const display_value = function (type, value, _precise = 0) {
  if (type === "integer" || type === "number") {
    return display_number_value(value, _precise)
  } else if (type === "datetime") {
    if (_.isNull(value) || _.isEmpty(value)) {
      return ""
    } else {
      if (typeof value == "string") {
        return _date.format(new Date(value), "yyyy-MM-dd HH:mm:ss")
      }
      return _date.format(parseISO(value), "yyyy-MM-dd HH:mm:ss")
    }
  } else if (type === "date") {
    if (_.isNull(value) || _.isEmpty(value)) {
      return ""
    } else {
      if (typeof value == "string") {
        return _date.format(new Date(value), "yyyy-MM-dd")
      }
      return _date.format(parseISO(value), "yyyy-MM-dd")
    }
  } else if (_.isNull(value)) return ""
  return value
}

export const display_options_value = function (value, options) {
  let option = _.find(options, { value })
  if (option) return option.label
  return ""
}

export const goto = function (vm, name, query) {
  vm.$router.push({ name, query })
}

export const get_cache_key = function (object) {
  let keys = _.keys(object)
  let sortedKeys = keys.sort(function (a, b) {
    if (a > b) {
      return 1
    }
    if (b > a) {
      return -1
    }
    return 0
  })
  let s = _.map(sortedKeys, k => {
    let v = object[k]
    return `${k}:${v}`
  })
  let t = s.join(".")
  // console.log(t)
  return md5(t)
}
